import React, { ReactNode } from 'react'
import { v4 as uuid } from 'uuid'
import { useQueries } from '@tanstack/react-query'
import { AccordionSection } from '../../../common/AccordionSection'
import { getGroupSubtitle } from '../helpers'
import { getUnitTitle } from '../../RegisterUnitList/helpers'
import { RegisterUnitItem } from '../../RegisterUnitItem'
import { Option } from '../../../common/Dropdown'
import { IGroupModel } from '../../../../interfaces/models/groups.interfaces'
import { unitQueries } from '../../../../api/units'

interface RegisterGroupUnitListItemProps {
  group: IGroupModel
  dropdownOptions: Option[]
}

export const RegisterGroupUnitListItem = ({
  group,
  dropdownOptions,
}: RegisterGroupUnitListItemProps): ReactNode => {
  const { data } = useQueries({
    queries:
      group?.unitsList?.map(({ unitId }) => unitQueries.getUnit(unitId)) || [],
    combine: (responses) => {
      return {
        data: responses.flatMap((query) => query.data || []),
      }
    },
  })

  return (
    <AccordionSection
      className="md:w-1/2 md:max-w-full"
      key={group._id}
      title={group.name}
      subtitle={getGroupSubtitle(group)}
      dropdownOptions={dropdownOptions}
      items={data.map((_unit) => ({
        id: uuid(),
        title: _unit ? getUnitTitle(_unit) : '',
        content: (
          <RegisterUnitItem
            unit={_unit}
            enableDelete={false}
            enableUpdate={false}
          />
        ),
      }))}
    />
  )
}
